import React from "react";
import { BrowserRouter, Routes as RouterRoutes, Route } from "react-router-dom";
import ScrollToTop from "components/ScrollToTop";
import ErrorBoundary from "components/ErrorBoundary";
import NotFound from "pages/NotFound";
import LoginPage from './pages/login';
import BikeAnalysisResults from './pages/bike-analysis-results';
import UserDashboard from './pages/user-dashboard';
import UpgradeRecommendations from './pages/upgrade-recommendations';
import Wishlist from './pages/wishlist';
import Register from './pages/register';
import LocalShopFinder from './pages/local-shop-finder';
import PhotoUpload from './pages/photo-upload';

const Routes = () => {
  return (
    <BrowserRouter>
      <ErrorBoundary>
      <ScrollToTop />
      <RouterRoutes>
        {/* Define your route here */}
        <Route path="/" element={<BikeAnalysisResults />} />
        <Route path="/login" element={<LoginPage />} />
        <Route path="/bike-analysis-results" element={<BikeAnalysisResults />} />
        <Route path="/user-dashboard" element={<UserDashboard />} />
        <Route path="/upgrade-recommendations" element={<UpgradeRecommendations />} />
        <Route path="/wishlist" element={<Wishlist />} />
        <Route path="/register" element={<Register />} />
        <Route path="/local-shop-finder" element={<LocalShopFinder />} />
        <Route path="/photo-upload" element={<PhotoUpload />} />
        <Route path="*" element={<NotFound />} />
      </RouterRoutes>
      </ErrorBoundary>
    </BrowserRouter>
  );
};

export default Routes;
